import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/device/')({
  component: () => <Navigate replace to="/device/remarkable" />,
});
